export const LG_SIZE = 'lg';
export const SM_SIZE = 'sm';
export const DEFAULT_SIZE = LG_SIZE;
